import { __assign, __rest } from "tslib";
import React from 'react';
import Box from './Box';
export default function Grid(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Box, __assign({ display: "grid" }, props), children));
}
